<template lang="pug">
  form.product-form(@submit.prevent="addToCart", novalidate)
    div.product-display__gift-cart(v-if="isGiftCard")    
      select.product-display__gift-cart__dropdown(v-model="selectedGiftCard")
        option(disabled) Choose Amount
        option(v-for="option in variants", :value="option.id" :key="option.id") {{ option.title }}
      submit-button(
          :label="buttonLabel",
          :inline="true",
          :disabled="false",
          :isSelected="isSelected",
          :loading="adding",
          :full="true"
        )
    div(v-else)  
      .product-form__options
        product-option.product-form__variant-selector(
          v-model="selectedOption1",
          v-if="optionCount > 0 && variants.length > 1",
          option="option1",
          :label="option1Label",
          :product="product",
          :class="option1Label.toLowerCase()",
          :availableOptions = "availableOptions[0]"
          :colorsByOption = "getColorsByOption"
          :bundleUrl = "getBundleUrl"
          :bundleMaterial = "getBundleMaterial"
        )
        product-option.product-form__variant-selector(
          v-model="selectedOption2",
          v-if="optionCount > 1 && variants.length > 1",
          option="option2",
          :label="option2Label",
          :product="product",
          v-on:is-selected-false="isSelectedFalse",
          :isSelected="isSelected",
          :class="[ option2Label.toLowerCase(), { 'u-hidden': selectedOption2 === 'Default Title' || selectedOption1 === 'NO COLOR' || selectedOption1 === 'N/A' || selectedOption1 === 'NS' || product.hide_variants }]",
          :availableOptions = "availableOptions[1]"
          :colorsByOption = "getColorsByOption" 
          :bundleUrl = "getBundleUrl"
          :bundleMaterial = "getBundleMaterial"
        )
      .product-form__atc
        .product-form__price
          h3(v-if="comparePrice !== null") 
            s {{comparePrice}}
            span {{currentPrice}}
          h3(v-else) {{ currentPrice }}
        submit-button(
          :label="buttonLabel",
          :inline="true",
          :disabled="false",
          :isSelected="isSelected",
          :loading="adding",
          :full="true"
        )
</template>

<script>
  import { mapState } from 'vuex'
  import ProductOption from '../product/ProductOption.vue'
  import SubmitButton from '../buttons/SubmitButton.vue'
  import Icon from '../basic/Icon.vue'
  
  export default {
    name: 'ProductForm',
    components: { ProductOption, SubmitButton, Icon },
    props: {
      product: Object ,
      variants: Array,
      bundle: Array,
    },
    data () {
      return {
        adding: false,
        selectedOption1: '',
        selectedOption2: '',
        selectedOption3: '',
        variantId:'',
        selectOption2:'',
        isSelected: true,
        item: {
          Name: this?.product?.title,
          ProductID: this?.product?.id,
          Categories: this?.product?.collections,
          ImageURL: "https:" + this?.product?.images[0],
          URL: this?.product?.url,
          Brand: this?.product?.vendor,
          Price: this?.product?.price,
          CompareAtPrice: this?.product?.compare_at_price,
        },
        addedToWishlist: false,
        swymInjectObserver: null,
        swymChangeObserver: null,
        swymInject: null,
        mobileStickyAtcButton: false,
        modelDescription: '',
        selectedGiftCard: 'Choose Amount',
        isGiftCard: this.product.product_type.toLowerCase() === 'gift card'
      }
    },
    computed: {
      ...mapState({
        allProducts: state => state.products.all,
        currentVariantId: state => state.productPage.currentVariantId,
      }),
      selectedVariant () {
        if(this?.optionCount === 1 && this.isGiftCard && this.selectedGiftCard !== '' ){
          return this?.product?.variants?.find(variant => (this?.selectedGiftCard === variant.id));

        } else if (this?.optionCount === 1 && this?.selectedOption1 !== '') {
          return this?.product?.variants?.find(variant => (this?.selectedOption1 === variant.option1))

        } else if (this?.optionCount === 2 && this?.selectedOption1 !== '' &&  this?.selectedOption2 !== '') {
          return this?.product.variants?.find(variant => (this?.selectedOption1 === variant.option1 && this?.selectedOption2 === variant.option2))

        } else if (this?.optionCount === 3 && this?.selectedOption1 !== '' &&  this.selectedOption2 !== '' && this?.selectedOption3 !== '') {
          return this?.product.variants?.find(variant => (this?.selectedOption1 === variant.option1 && this?.selectedOption2 === variant.option2 && this?.selectedOption3 === variant.option3))

        } else {
          // return this.product.variants[0];
          return (this?.variantId !== null) ? this?.product?.variants.find(variant => variant.id === Number(this?.variantId)) : this?.product?.variants.find(variant => variant.id === this?.product?.variants[0].id)
        }
      },  
      isAvailable () {
        if(this.isGiftCard && this?.selectedVariant)
          return true;

        return !!this?.selectedVariant ? this?.selectedVariant?.available : false;
      },
      allOptionsHaveSelections () {
        if (this?.optionCount === 1) { return this?.selectedOption1 !== '' }
        if (this?.optionCount === 2) { return this?.selectedOption1 !== '' && this?.selectedOption2 !== ''; }
        if (this?.optionCount === 3) {
          return this?.selectedOption1 !== '' &&
          this?.selectedOption2 !== '' &&
          this?.selectedOption3 !== '';
        }
      },
      isFinalSale () {
        return this?.product.metafields.badge.text === "FINAL SALE";
      },
      buttonLabel () {
        return 'Add to Cart'; 
      },
      // variants
      optionCount () {
        return this?.product?.options.length;
      },
      option1Label () {
        return this?.product?.options[0]?.name
      },
      option2Label () {
        return this?.product?.options[1]?.name
      },
      currentPrice () {
        return `$${this?.selectedVariant?.price}`
      },
      comparePrice() {
        if(this?.selectedVariant?.compare_at_price !== '' && this?.selectedVariant?.price !== this?.selectedVariant?.compare_at_price){
          return `$${this?.selectedVariant?.compare_at_price}`;
        }
        else{
          return null;
        }
      },
      selectedColor () {
        if (this.option1Label === 'Color') {          
          return this.selectedOption1
        }

        if (this.option2Label === 'Color') {
          return this.selectedOption2
        }
      },
      availableOptions () {
        let availableOptions = [];
        availableOptions[0] = this.filterOptionBasedOnSelections(1);
        availableOptions[1] = this.filterOptionBasedOnSelections(2);

        return availableOptions;
      },
      getColorsByOption () {
        if (this.option1Label === 'Color' && this.option2Label === undefined){
          console.log('tru');
          return this.product.variants.map((variant) => { console.log(variant['option1']); return variant[`option1`] });
        }
        else{
          return this.product.variants.filter(variant => variant.option2 == this.selectedOption2).map((variant) => { console.log(variant['option1']); return variant[`option1`] });
        }
      },
      getBundleUrl(){
        return this?.bundle[0]?.productUrl
      },
      getBundleMaterial() {
        return this?.bundle[0]?.materialType
      },
      swiper(){
        return this.$parent.$refs.mySwiper;
      }      
    },
    created () {
      this.setOptionsFromUrl();
    },
    mounted () {
      // check this 
    },
    beforeDestroy () {
      this.swymChangeObserver.disconnect();
    },
    methods: {     
      isSelectedFalse() {
        this.isSelected = false;
      },
      addToCart () {
        
        let addProduct = {
          id: this?.selectedVariant.id,
          quantity: 1
        } 
        if (addProduct.id) {
          this.adding = true
          this.$store.dispatch('cart/addItem', addProduct)
            .then(() => this.$store.dispatch('cart/openSidecart'))
            .catch(error => this.$store.dispatch('toast/send', { text: error, type: 'error' }))
            .then(() => this.adding = false)
        } else {
          console.error('Cannot add to cart, invalid product ID')
          this.$store.dispatch('toast/send', { text: 'Could not add this product to your cart', type: 'error' })
        }
      },
      setOptionsFromUrl () {
        // checking this.
        const url = new URL(window.location.href);
        this.variantId = url.searchParams.get('variant');
        if (this?.variantId?.length) {
          const initialVariant = this?.product?.variants?.find(variant => (variant.id === Number(this.variantId)));

          if(!!initialVariant){
            const options = [initialVariant.option1, initialVariant.option2];
            this.selectOption2 = initialVariant.option2;
            options.forEach((option, idx) => {
              if (option) {
                this[`selectedOption${idx + 1}`] = options[idx];
              }
            });
          }
        };

      },
      setVariantParam (id) {
        const url = new URL(window.location.href);
        url.searchParams.set('variant', id);
        window.history.replaceState({}, '', url.href);
      },
      hasTwoOptionsSelectedOne () {
        return this.optionCount === 2 && !this.selectedOption2
      },
      twoOptionsVariantId () {
        const variant = this?.product?.variants?.find(variant => (this.selectedOption1 === variant.option1 && this?.product?.variants[0].option2))
        return variant?.id
      },
      filterOptionBasedOnSelections (optionToFilter) {
        let self = this;
        this.product?.variants.forEach((vr, index) => {
          let _v = self.variants.filter(v => v.id === vr.id);
          self.product.variants[index].available = _v[0].qty > 0
        });

        let variants = this?.product?.variants;
        const selectedOption1 = this.selectedOption1;
        const selectedOption2 = this.selectedOption2;

        if (this.selectedOption1 !== '' && optionToFilter !== 1) {
          variants = variants.filter(function(variant) {    
            return variant.option1 === selectedOption1 && variant.available === true;
          });
        }

        if (this.selectedOption2 !== ''  && optionToFilter !== 2) {
          
          variants = variants.filter(function(variant) {
            return variant.option2 === selectedOption2 && variant.available === true;
          });
        }

        return variants.map(function (variant) { return variant[`option${optionToFilter}`] });
      }    
    },
    watch: {
      selectedColor(newVal, oldVal){
        
       if(this?.modelSizeSwitch?.length < 1){
          this.modelDescription = this.modelSize;
        }else{
          let obj = this?.modelSizeSwitch?.find(val => val.color.toLowerCase().replace(/\s/g, "") == newVal.toLowerCase().replace(/\s/g, ""));
          this.modelDescription = obj?.description;
        }

      },
      selectedVariant (newVal, oldVal) {
        // If a variant is now selected, and either it differs from the previously selected variant
        // OR its ID doesn't match the store ID value (happens the first time the selectedVariant property
        // 'changes' since this watcher won't fire on initial value selection), dispatch update to store
        
        if(!newVal){
          let firstInput = document.querySelectorAll(".color-selector .swatch__label input")[0];
          if(!!firstInput)
            firstInput.click()
        }

        if(!this.isGiftCard)
          console.log(this?.selectedVariant);
          console.log(this.$parent.$refs?.mySwiper.$el?.swiper);

          let imageId = this?.selectedVariant.image_id;
          Array.from(this.$parent.$refs?.mySwiper.$el?.swiper.slides).findIndex((image, index) => {
            let slideImageId = image.firstChild.getAttribute('image-id');
            console.log(slideImageId, imageId);
            if (parseInt(slideImageId) === imageId){
              this.$parent.$refs?.mySwiper.$el?.swiper.slideTo(index, 500);
            }
          })
          // this.$parent.$refs?.mySwiper.$el?.swiper.slideTo(this?.selectedVariant.position - 1, 500);

        if (newVal && (newVal !== oldVal || this?.selectedVariant.id !== this?.currentVariantId)) {
          this.setVariantParam(this?.selectedVariant.id);
          this.$store.dispatch('productPage/selectVariant', this?.selectedVariant.id);
        }
        if (this.hasTwoOptionsSelectedOne()){
          const variantId = this.twoOptionsVariantId();
          this.setVariantParam(variantId);
          this.$store.dispatch('productPage/selectVariant', variantId);
        }
      },
    }
  }
</script>

<style lang="scss">

    .price__btn23{
        display:flex;
        justify-content:space-between;
    }
.product-form {
  position: relative;

  h3 {
    font-family: 'mencken-std';
    font-size: 30px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.33;
    letter-spacing: normal;
    text-align: left;
    color: #fff;
    margin-bottom: 0;
  }
  
  .button {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    padding: 10px;
    border-radius: 3px;
    color: #fff;
    background-color: #edc8a3;
    width: 170px;
    height: 44px;
    cursor: pointer;
    border:0;

    span {
      font-family: 'basiersquaremono';
      font-size: 14px;
      font-weight: normal;
      font-stretch: normal;
      font-style: normal;
      line-height: 1;
      letter-spacing: 0.98px;
      text-align: center;
      color: #000!important;
      text-transform: uppercase;
    }

    &[disabled="disabled"]{
      cursor: default;

      span {
        opacity: 0.25;
      }
    }

  }

  &__options {
    display: flex;
    flex-wrap: wrap;
    
    .material{
      order: 1;
    }

    .color {
      order: 2;
    }
  }

  &__atc {
    display: flex;
    justify-content: space-between;
    flex-direction: row;
    padding-bottom: 40px;
    margin-bottom: 30px;
    border-bottom: 1px solid #494949;
  }

}
</style>
